// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"60e03b77","239":"b5b065a3","453":"219fa1ba","455":"bac50f4a"}[chunkId] + ".chunk.js";
};